import { useStaticUrls } from 'platform-components';
import { Route, Switch } from 'platform-components/src/components/router/router';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import ChangesNotification from 'common.components/changes-notification/changes-notification';
import { TeacherHeader } from 'common.components/TeacherHeader/TeacherHeader';

import { Content } from './__content/main__content';

export const LibraryMain = () => {
    const intl = useIntl();
    const staticUrls = useStaticUrls();

    return (
        <>
            <Helmet title={intl.formatMessage({ id: 'libraryPage.title' })} />
            <TeacherHeader />
            <ChangesNotification />
            <Switch>
                <Route component={Content} exact key="mainPageContent" path={staticUrls.labLibraryMain} />
                <Route component={Content} exact key="mainPageContent" path={staticUrls.labLibraryTeamMain} />
            </Switch>
        </>
    );
};
